import React, { useState } from "react";
import { getCardImage } from "../../resultVisuals/cardAssets";
import CardImg from "../../../../components/CardImg";

/**
 * Teenpatti Joker 20-20 (joker20) card overlay — reference markup:
 *   .casino-video-cards[.hide-cards] > .casino-cards-shuffle (toggle) + .casino-video-cards-container
 *     (.joker-card(h4.text-playerb "Joker" + card[0]), div.mt-2(A = cards[1,3,5]), div(B = cards[2,4,6]))
 * "1" = card not dealt (back image). Hidden while cards[0] is "1" or after the shuffle toggle.
 */
export default function Joker20CardsOverlay({ cards: rawCards }) {
  const [showCards, setShowCards] = useState(true);
  const cards = (Array.isArray(rawCards) ? rawCards : String(rawCards || "").split(",")).map((c) =>
    String(c ?? "").trim()
  );
  if (!rawCards || !cards.length) return null;

  const hide = !showCards || cards[0] === "1";

  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  const card = (idx) => (
    <span>
      <CardImg src={getCardImage(cards[idx])} alt="" />
    </span>
  );

  return (
    <div className={`casino-video-cards${hide ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={() => cards[0] !== "1" && setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        <div className="joker-card">
          <h4 className="text-playerb">Joker</h4> {card(0)}
        </div>{" "}
        <div className="mt-2">
          {card(1)} {card(3)} {card(5)}
        </div>{" "}
        <div>
          {card(2)} {card(4)} {card(6)}
        </div>
      </div>
    </div>
  );
}
